import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ListGroup, ListGroupItem } from 'reactstrap';

const Container = styled.div`
  border-style: dashed !important;
`;

const humanizeFileSize = (bytes) => {
  let i = -1;
  const byteUnits = [' kB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB'];

  do {
    // eslint-disable-next-line
    bytes /= 1024;
    // eslint-disable-next-line
    i++;
  } while (bytes > 1024);

  return Math.max(bytes, 0.1).toFixed(1) + byteUnits[i];
};

const Dropzone = ({ setFile, acceptFileTypes }) => {
  const onDrop = useCallback((acceptedFiles) => {
    const reader = new FileReader();

    reader.onabort = () => console.info('file reading was aborted');
    reader.onerror = err => console.error('file reading has failed', err);
    reader.onloadend = (evt) => {
      const file = {
        title: evt.target.file.name,
        type: evt.target.file.type,
      };

      if (acceptFileTypes === 'application/json') {
        file.json = JSON.parse(evt.target.result);
      } else {
        file.base64 = reader.result;
      }

      setFile(file);
    };

    acceptedFiles.forEach((file) => {
      reader.file = file;

      if (acceptFileTypes === 'application/json' || acceptFileTypes === 'text/csv') {
        reader.readAsText(file);
      } else {
        reader.readAsDataURL(file);
      }
    });
  }, []);

  const {
    acceptedFiles,
    rejectedFiles,
    getRootProps,
    getInputProps,
    isDragActive,
  } = useDropzone({ onDrop, accept: acceptFileTypes });

  return (
    <Container {...getRootProps({ className: 'bg-light rounded border border-muted text-muted' })}>
      <input {...getInputProps()} />

      <h5 className="text-center pt-3">
        {!isDragActive
          ? (
            <>
              {/* eslint-disable-next-line */}
              <div>Drag &apos;n drop file ... or <a className="text-primary">click to pick</a>.</div>
            </>
          ) : 'Drop file ...'
    }
      </h5>

      {!acceptedFiles.length && !rejectedFiles.length ? (
        <div className="text-center">
          <FontAwesomeIcon icon="cloud-upload-alt" size="5x" />

          <p className="pt-3">Acceptable files: {acceptFileTypes.includes('image') ? 'images' : 'all file types'}</p>
        </div>
      ) : (
        <p className="px-3">
          <h6>Resulting file</h6>

          <ListGroup>
            {acceptedFiles.map(file => (
              <ListGroupItem key={file.path}>
                <FontAwesomeIcon icon="check" className="text-success" />
                <span className="d-inline-block pl-2">
                  {file.path} - {humanizeFileSize(file.size)}
                </span>
              </ListGroupItem>
            ))}

            {rejectedFiles.map(file => (
              <ListGroupItem key={file.path}>
                <FontAwesomeIcon icon="times" className="text-danger" />
                <span className="d-inline-block pl-2">
                  {file.path}
                </span>
              </ListGroupItem>
            ))}
          </ListGroup>
        </p>
      )}
    </Container>
  );
};

Dropzone.propTypes = {
  setFile: PropTypes.func.isRequired,
  acceptFileTypes: PropTypes.string.isRequired,
};

export default Dropzone;
